import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';
import _isEmpty from 'lodash/isEmpty';
import Strapi from '../../../../components/strapi';
import LoadingPage from '../../../../components/loadingpage';
import useWindowWidth from '../../../../components/hooks/useWindowWidth';
import GetStrapiContent from '../../../../components/strapi/getstrapicontent';

export default function AIStatement({location}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const {i18n} = useTranslation();
  const width = useWindowWidth();
  const {productType} = useParams();
  const {strapiContent} = GetStrapiContent(
    'COMPANY_AI_STATEMENT',
    setIsLoaded,
    location,
    true,
    productType
  );
  if (!isLoaded || _isEmpty(strapiContent)) return <LoadingPage />;

  return (
    <div>
      {strapiContent.map((s, i) => (
        <div key={`ai-statement-page-strapi-sec${i}`}>
          <Strapi
            content={s}
            width={width}
            productPage={'ai-statement'}
            i18n={i18n}
          />
        </div>
      ))}
    </div>
  );
}
